import React,{useEffect,useState} from 'react';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';

import appUrl from '../../../../constants/appUrl';

const ComplainHandling =  ({product}) => {
    
    const [complaintList, setComplaintList] = useState([]);

    console.log("Allllllllllllllllllllllllllll",product)
    const GetComplaintById = async ( productId) => {
        console.log('productId', productId)
        try {
            const response = await fetch(`${appUrl.baseUrl}api/Complaint/GetComplaintByProductId/${productId}`);
            const data = await response.json();
            setComplaintList(data);
  
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };
  
    useEffect(() => {
        if(product && product.productId) {
            GetComplaintById(product.productId);
        }
    }, [product]);
    const renderAttachment = () => {
        return <i className="pi pi-eye"></i>;
    };
    const actionTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-pencil" className="custom-btn-edit" />
            </div>
        );
    }
    return (
        <div className='grid'>
            <div className="md:col-10"></div>
            <div className='md:col-2'>
                <InputText className="w100" placeholder="Search" />
            </div>
            <div className='md:col-12' >
                <DataTable
                    value={complaintList}
                    scrollable
                    scrollHeight="500px"
                    rows={5}
                    paginator
                >
                    <Column field='email' header="Complaint Description" />
                    <Column field='phone' header="Complaint Category" />
                    <Column field='' header="Attachment" body={renderAttachment} />
                    <Column header="Action" body={actionTemplate} style={{ minWidth: "12rem" }} />
                </DataTable>
            </div>
        </div>
    )
}

export default ComplainHandling